<template>
  <div id="app" class="app_aa">
    <head-guide></head-guide>
    <!-- <transition :name="'vux-pop-' + (direction === 'forward' ? 'in' : 'out')" >
        <keep-alive :include='includePage'>
            <router-view class='router-view'>
        </keep-alive>
    </transition>-->
    <router-view/>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
import headGuide from "@/components/header/headGuide";
import footGuide from "@/components/footer/footGuide";
export default {
  name: "App",
  components: {
    headGuide,
    footGuide
  },
  mounted() {
  }
};
</script>
<style lang="scss">
@import "src/style/common";
.el-carousel__container {
  height: 870px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators--outside {
  display: none;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: #fff;
}
.el-carousel__arrow {
  width: 89px;
  height: 89px;
  border: solid 1px #ffffff;
  font-size: 30px;
  margin-left: 100px;
  margin-right: 100px;
}
.el-menu-demo {
  text-align: right;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #eee;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #fff;
  color: #333;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: #fff;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
  color: none;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 60px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid #fff;
  color: #909399;
}
.el-collapse-item__header {
  height: 80px;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
  font-weight: 800;
  -webkit-transition: border-bottom-color 0.3s;
  transition: border-bottom-color 0.3s;
  outline: 0;
  padding-top: 20px;
  font-size: 36px;
}
.el-collapse-item:last-child {
  border-top: 1px solid #fff;
  margin-top: -1px;
}
.el-collapse-item:nth-child(2) {
  margin-top: -1px;
}
.el-collapse-item__header i {
  font-size: 25px;
}
.el-collapse {
  border-top: #fff;
  border-bottom: #fff;
}
.el-collapse-item__content {
  font-size: 16px;
  color: #fff;
}
.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
  background-color: transparent;
}
.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: transparent;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue